var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("面板区")))]), _c("span", {
    attrs: {
      slot: "handle"
    },
    slot: "handle"
  }, [_vm._v(_vm._s(_vm.$t("蓝框为当前可编辑的区域可直接点击面板添加")))]), _vm.menu.indexOf("dashboardDataBoard") > -1 ? _c("div", {
    staticStyle: {
      "margin-top": "5px",
      color: "#999"
    },
    attrs: {
      slot: "des"
    },
    slot: "des"
  }, [_vm._v(" * " + _vm._s(_vm.$t("按照面板分类配置每个分类的页面，未配置的页面默认为无权限，前端不显示")) + " ")]) : _vm._e()]), _c("div", {
    staticClass: "btnBox"
  }, _vm._l(_vm.panelList, function (item, index) {
    return _c("div", {
      key: item.id,
      staticClass: "marginR15 marginB15 btnItem",
      on: {
        click: function ($event) {
          return _vm.handlePanel(item, index);
        }
      }
    }, [item.remarks ? _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.remarks) + " ")]), _vm._v(" " + _vm._s(item.name) + " ")], 2) : _c("span", [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 0), _c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("页面预览")))])]), _c("a-card", {
    attrs: {
      hoverable: true
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 15
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 0 ? "hit" : "",
    on: {
      click: function ($event) {
        _vm.current = 0;
      }
    }
  }, [_vm.previewList[0] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[0])) + " "), _vm.previewList[0].panel.length != 0 && _vm.previewList[0].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[0].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame)))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _vm.previewList[0] ? _c("div", [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(0);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[0]
    }
  })], 1) : _vm._e()])], 1), _c("a-col", {
    attrs: {
      span: 9
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 1 ? "hit" : "",
    on: {
      click: function ($event) {
        _vm.current = 1;
      }
    }
  }, [_vm.previewList[1] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[1])) + " "), _vm.previewList[1].panel.length != 0 && _vm.previewList[1].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[1].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _vm.previewList[1] ? _c("div", [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(1);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[1]
    }
  })], 1) : _vm._e()])], 1)], 1), _c("a-row", {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 15
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 2 ? "hit" : "",
    on: {
      click: function ($event) {
        _vm.current = 2;
      }
    }
  }, [_vm.previewList[2] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[2])) + " "), _vm.previewList[2].panel.length != 0 && _vm.previewList[2].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[2].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _vm.previewList[2] ? _c("div", [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(2);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[2]
    }
  })], 1) : _vm._e()])], 1), _c("a-col", {
    attrs: {
      span: 9
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 3 ? "hit" : "",
    on: {
      click: function ($event) {
        _vm.current = 3;
      }
    }
  }, [_vm.previewList[3] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[3])) + " "), _vm.previewList[3].panel.length != 0 && _vm.previewList[3].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[3].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _vm.previewList[3] ? _c("div", [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(3);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[3]
    }
  })], 1) : _vm._e()])], 1)], 1), _c("a-row", {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 4 ? "hit" : "",
    on: {
      click: function ($event) {
        _vm.current = 4;
      }
    }
  }, [_vm.previewList[4] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[4])) + " "), _vm.previewList[4].panel.length != 0 && _vm.previewList[4].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[4].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _vm.previewList[4] ? _c("div", [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(4);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[4]
    }
  })], 1) : _vm._e()])], 1)], 1)], 1), _vm.isPanelShow ? _c("custom-model", {
    ref: "customFrom",
    attrs: {
      customerId: _vm.customerId
    },
    on: {
      cancel: function ($event) {
        _vm.isPanelShow = false;
      },
      ok: _vm.addTemplateFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };